import { render } from "./addorg.vue?vue&type=template&id=47c6f5cc"
import script from "./addorg.vue?vue&type=script&lang=js"
export * from "./addorg.vue?vue&type=script&lang=js"

import exportComponent from "/home/salah/dev/yoda-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__